import { useMutation, useQuery } from '@tanstack/react-query'

import { useDispatch } from '@tabeeb/store'
import { useApi } from '@tabeeb/modules/shared/utils/API'
import { onAddErrorNotification } from '@tabeeb/modules/notification/actions'

import { ArticlesQueryKeys } from '../queries'

export interface UseContentTrainingMaterialUsersProps {
  enabled?: boolean
  id?: number
  onError?: (error: unknown) => void
  onAssigned?: (userIds: number[]) => void
}

export const useContentTrainingMaterialUsers = ({
  enabled,
  id,
  onError,
  onAssigned,
}: UseContentTrainingMaterialUsersProps) => {
  const dispatch = useDispatch()

  const { articleServiceApi: api } = useApi()

  const query = useQuery({
    queryKey: [ArticlesQueryKeys.ContentTrainingMaterialUsers, id],
    queryFn: () => api.contentTrainingMaterials.getUsersAssignedToTrainingMaterialAsync(id!),
    enabled,
    onError,
  })

  const assignUserMutation = useMutation({
    mutationFn: (userIds: number[]) =>
      api.contentTrainingMaterials.assignUsersToTrainingMaterialsAsync(id!, {
        UserIds: userIds,
      }),
    onSuccess: (_, userIds) => {
      query.refetch()

      onAssigned?.(userIds)
    },
    onError: (error) => {
      dispatch(onAddErrorNotification({ message: 'Failed to assign user' }))
    },
  })

  return {
    loading: query.isLoading,
    users: query.data ?? [],
    onAssignUsers: assignUserMutation.mutate,
    onReload: query.refetch,
  }
}

export default useContentTrainingMaterialUsers
